<script lang="ts" setup>
  import { computed } from 'vue';
  import type { GameConfig, PauseReason, PhaseLengthsRange, Range } from '../../../shared/api/game.ts';
  import GameSettingsContainer from './lobby/GameSettingsContainer.vue';
  import ModalSheet from './ModalSheet.vue';
  import HostPauseButtonContainer from './round/HostPauseButtonContainer.vue';

  type Settings = { gameConfig: GameConfig; roundsRange: Range; phaseLengthsRange: PhaseLengthsRange };

  const props = defineProps<{ isHost: boolean; isChooser: boolean; reason?: PauseReason; settings?: Settings }>();

  const message = computed(() => {
    if (props.reason === 'lost-host-device') {
      return props.isHost
        ? 'Spotify moved the song off the device you started the game on. Open Spotify there, then unpause'
        : "Spotify moved the song off the host's device. Waiting for the host to bring it back";
    }
    if (props.reason !== 'failed-choice') {
      return props.isHost ? 'Everyone waits until you unpause' : 'Waiting for the host to unpause';
    }
    const openSpotify = 'Open Spotify on your device, play a song, then unpause';
    if (props.isHost && props.isChooser) return `Spotify could not play your song. ${openSpotify} and choose again`;
    if (props.isHost) return `Spotify could not play the song. ${openSpotify}`;
    const song = props.isChooser ? 'your song' : 'the song';
    return `Spotify could not play ${song}. Waiting for the host to reconnect to Spotify`;
  });
</script>

<template>
  <ModalSheet :dismissible="false" title="Game paused">
    <p class="waiting">{{ message }}</p>
    <GameSettingsContainer
      v-if="isHost && settings"
      :config="settings.gameConfig"
      :phase-lengths-range="settings.phaseLengthsRange"
      :rounds-range="settings.roundsRange"
    />
    <template v-if="isHost" #actions>
      <HostPauseButtonContainer :paused="true" />
    </template>
  </ModalSheet>
</template>

<style scoped>
  .waiting {
    margin: 0;
    text-align: center;
  }
</style>
